import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector, {
  calculateStartAndEndTime, calculateStartTime,
} from '@avtechsoftware/react-component-library/src/components/common/DateRangeSelector/DateRangeSelector';
import { ReportRangeTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/ReportRangeTypes';
import { useSelector } from 'react-redux';
import AvtechApplicationCodes from '@avtechsoftware/ra-javascript-utilities/src/types/AvtechApplicationCodes';
import moment from 'moment-timezone';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';
import { selectSessionInformation } from '../../../../../../redux/slices/sessionSlice';
import { formatUnixTimestampToDateObject } from '../../../../../../utility/DateUtility';

function FilterModalPatternE({
  facetType,
  facetClass,
  facets,
  setFacets,
  updateFacet,
}) {
  const { timezone } = useSelector(selectSessionInformation);

  const [selectedOperator, setSelectedOperator] = useState(facetType.validOperators[0]);
  const [dateRangeData, setDateRangeData] = useState({
    timeRangeType: ReportRangeTypes.SIX_HOURS,
    startTime: facets.length > 0 ? formatUnixTimestampToDateObject(facets[0].value1) : new Date(),
    endTime: facets.length > 0 ? formatUnixTimestampToDateObject(facets[0].value2) : new Date(),
  });

  const handleSelectOperatorOnChange = (e) => {
    const { value } = e.target;
    setSelectedOperator(value);
    if (facets.length > 0) {
      const updatedOperatorTypeFacets = facets
        .map((facet) => ({ ...facet, operatorId: Number(value) }));
      setFacets(updatedOperatorTypeFacets);
    }
  };

  const handleUpdateFacetValue = (newValue1, newValue2, rangeTypeId) => {
    let newFacet;
    if (facets.length > 0) {
      newFacet = {
        ...facets[0],
        operatorId: Number(selectedOperator),
        value1: moment(newValue1).unix().toString(),
        value2: moment(newValue2).unix().toString(),
        rangeType: rangeTypeId,
      };
    } else {
      newFacet = {
        facetId: facetType.id,
        operatorId: Number(selectedOperator),
        value1: moment(newValue1).unix().toString(),
        value2: moment(newValue2).unix().toString(),
        rangeType: rangeTypeId,
      };
    }
    updateFacet(newFacet);
  };

  const handleDateSelectorOnChange = (updatedRangeData) => handleUpdateFacetValue(
    updatedRangeData.startTime,
    updatedRangeData.endTime,
    updatedRangeData.rangeTypeId,
  );

  const handleToggleRangeTypeMode = () => {
    const newRangeTypeId = dateRangeData
      .timeRangeType === 1 ? ReportRangeTypes.TWENTY_FOUR_HOURS : 1;
    const { startTime, endTime } = calculateStartAndEndTime(newRangeTypeId);
    handleUpdateFacetValue(startTime, endTime, newRangeTypeId);
  };

  React.useEffect(() => {
    if (facets.length > 0) {
      const editedFacet = facets[0];
      const start = formatUnixTimestampToDateObject(editedFacet.value1);
      const end = formatUnixTimestampToDateObject(editedFacet.value2);
      setSelectedOperator(editedFacet.operatorId);
      setDateRangeData({
        startTime: start,
        endTime: end,
        timeRangeType: editedFacet.rangeType,
      });
    } else {
      const currentTime = moment().toDate();
      handleUpdateFacetValue(
        calculateStartTime(ReportRangeTypes.SIX_HOURS, currentTime),
        currentTime,
        ReportRangeTypes.SIX_HOURS,
      );
    }
  }, [setFacets, updateFacet]);

  return (
    <div>
      <h6>
        {`${facetClass.getDescription()}`}
      </h6>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <select
              className="form-control"
              data-testid="operator-combobox"
              onChange={handleSelectOperatorOnChange}
              value={selectedOperator}
            >
              {
                facetClass.getOperatorSelectOptions().map((option) => (
                  <option key={option.label} value={option.value}>
                    {option.label}
                  </option>
                ))
                }
            </select>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <div className="col-auto d-inline-block">
              <DateRangeSelector
                updateDateRangeData={handleDateSelectorOnChange}
                reportRangeTypeId={dateRangeData.timeRangeType}
                startTime={dateRangeData.startTime}
                endTime={dateRangeData.endTime}
                toggleRangeTypeMode={handleToggleRangeTypeMode}
                timeZone={timezone}
                applicationCode={AvtechApplicationCodes.RAA}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
FilterModalPatternE.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number,
    validOperators: PropTypes.arrayOf(PropTypes.number),
    displayValue: PropTypes.string,
    modalType: PropTypes.number,
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape(searchFilterPropType)).isRequired,
  setFacets: PropTypes.func.isRequired,
  updateFacet: PropTypes.func.isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
};
export default FilterModalPatternE;
